/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React     from 'react';
import styles    from 'components/Fieldset/Fieldset.scss';

export default class Fieldset extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className={styles.fieldset}>
        <div className={[styles.legend, this.props.color && styles[this.props.color]].join(' ')}>{this.props.legend}</div>
        {
          this.props.descriptionWithHTML
            ? <div className={styles.description} dangerouslySetInnerHTML={{ __html: this.props.descriptionWithHTML }} />
            : <div className={styles.description}>{this.props.description}</div>
        }
        <div className={styles.fields}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Fieldset.propTypes = {
  legend: PropTypes.node,
  description: PropTypes.node,
};
